export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9281.7f1a9695.jpg";